import { render, staticRenderFns } from "./GameColor.vue?vue&type=template&id=97d00f20&scoped=true&"
import script from "./GameColor.vue?vue&type=script&lang=js&"
export * from "./GameColor.vue?vue&type=script&lang=js&"
import style0 from "./GameColor.vue?vue&type=style&index=0&id=97d00f20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d00f20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97d00f20')) {
      api.createRecord('97d00f20', component.options)
    } else {
      api.reload('97d00f20', component.options)
    }
    module.hot.accept("./GameColor.vue?vue&type=template&id=97d00f20&scoped=true&", function () {
      api.rerender('97d00f20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/wheel/components/GameColor.vue"
export default component.exports